<h1 mat-dialog-title>Some help:</h1>
<div mat-dialog-content>
  <h2>Definitions</h2>
  <dl>
    <dt>interest</dt>
    <dd>A charge for borrowed money generally a percentage of the amount borrowed</dd>
    <dt>principal</dt>
    <dd>A loan’s actual balance, excluding the interest owed for borrowing</dd>
    <dt>permium</dt>
    <dd>Payment for insurance</dd>
  </dl>

  <h2>Mortgage types:</h2>
  <dl>
    <dt>linear</dt><dd>A fixed amount will be payed towards the principal each month to make sure the mortgage has been payed of at the end of the contract</dd>
    <dt>Annuity</dt><dd>A fixed total amount (interest + principal) will be payed towards the mortgage each month. The mortgage will be payed of at the end of the contract.</dd>
    <dt>Interest Only</dt><dd>Only interest will be payed each month. The principal will remain untouched.</dd>
    <dt>Saving</dt><dd>A separate insurance is setup to make sure the principal is payed off in full at the end of the contract. A monthly premium is being payed towards this insurance. During this period, interest will be payed, but no principal.</dd>
  </dl>
</div>

